export const AUTHENTICATE = '[AUTH] AUTHENTICATE'
export const CHANGE_USER = '[AUTH] CHANGE_USER'
